import React from "react";

export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="30"
      height="31.23"
      viewBox="0 0 30 31.23"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rechteck_8035"
            data-name="Rechteck 8035"
            width="30"
            height="31.23"
            transform="translate(0 0)"
            fill="#fff"
          />
        </clipPath>
      </defs>
      <g id="Gruppe_8161" data-name="Gruppe 8161" transform="translate(0 0)">
        <g
          id="Gruppe_8153"
          data-name="Gruppe 8153"
          transform="translate(0 0)"
          clip-path="url(#clip-path)"
        >
          <path
            id="Pfad_7818"
            data-name="Pfad 7818"
            d="M28.17,18.844a5.769,5.769,0,0,1-.159,1.347H22.84a5.77,5.77,0,0,1-.159-1.347v-.483h-1.83v.483a7.534,7.534,0,0,0,2.88,5.925,7.682,7.682,0,0,0-2.88,5.979v.483h1.83v-.483a5.78,5.78,0,0,1,.175-1.408H28a5.8,5.8,0,0,1,.175,1.408v.483H30v-.483a7.682,7.682,0,0,0-2.88-5.979A7.534,7.534,0,0,0,30,18.844v-.483H28.17Zm-.986,8.666H23.666a5.7,5.7,0,0,1,1.759-1.7,5.7,5.7,0,0,1,1.759,1.7m-1.759-3.789a5.675,5.675,0,0,1-1.784-1.7H27.21a5.676,5.676,0,0,1-1.785,1.7M20.832,13.453a4.786,4.786,0,0,0,0-5.316,4.9,4.9,0,0,0-.515-2.514,4.827,4.827,0,0,0-2.156-2.132,3.867,3.867,0,0,0-.732-1.019A4.887,4.887,0,0,0,13.705.807h-.257A4.86,4.86,0,0,0,10.792,0,5.509,5.509,0,0,0,8.068.8,4.835,4.835,0,0,0,4.23,2.388a5.265,5.265,0,0,0-.74,1.086A4.816,4.816,0,0,0,.813,8.117,4.878,4.878,0,0,0,0,10.789a4.942,4.942,0,0,0,.805,2.674,4.9,4.9,0,0,0,.515,2.5,4.821,4.821,0,0,0,2.149,2.13,5.319,5.319,0,0,0,.748,1.1,4.733,4.733,0,0,0,1.994,1.319V25.68h1.83V20.774l.075,0a4.866,4.866,0,0,0,2.664.81,5.551,5.551,0,0,0,2.716-.8h.035v4.9h1.83V20.514a4.949,4.949,0,0,0,2.054-1.4,3.936,3.936,0,0,0,.729-1.007A4.825,4.825,0,0,0,20.31,15.97a5.018,5.018,0,0,0,.522-2.517M2.955,6.445A3.842,3.842,0,0,1,4.835,4.822a6.338,6.338,0,0,1,.756-1.21,3.447,3.447,0,0,1,2.9-.98,4.875,4.875,0,0,1,2.3-.8,3.977,3.977,0,0,1,2.151.806A3.583,3.583,0,0,1,16.072,3.7c.512.563.285.394.737,1.132a3.849,3.849,0,0,1,1.874,1.618,2.966,2.966,0,0,1,.284.866H2.671a2.893,2.893,0,0,1,.285-.876M17.085,9.15a2.856,2.856,0,0,1-1.724,1.673V9.15Zm-3.554,3.66v.915a2.745,2.745,0,0,1-5.49,0V12.81h1.83V10.98H8.041V9.15h5.49v1.83H11.7v1.83ZM6.211,9.15v1.672A2.758,2.758,0,0,1,4.539,9.15ZM19,12.962a4.233,4.233,0,0,1-.316,2.178A3.845,3.845,0,0,1,16.8,16.763a4.442,4.442,0,0,1-.818,1.209,3.446,3.446,0,0,1-2.9.979,4.844,4.844,0,0,1-2.305.8A4.048,4.048,0,0,1,8.6,18.93a3.5,3.5,0,0,1-3.023-.961,6.385,6.385,0,0,1-.758-1.22,3.854,3.854,0,0,1-1.868-1.617,4.154,4.154,0,0,1-.307-2.156,4.1,4.1,0,0,1-.814-2.19A3.767,3.767,0,0,1,2.579,8.73a4.586,4.586,0,0,0,3.633,3.988v1.007a4.575,4.575,0,0,0,9.15,0V12.719a4.63,4.63,0,0,0,3.693-3.986l.339.567a2.922,2.922,0,0,1,.414,1.5A4.044,4.044,0,0,1,19,12.962"
            transform="translate(0 -0.001)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};
